import React from 'react';
import { string, arrayOf, shape, bool, number } from 'prop-types';
import classnames from 'classnames';
import { useQuery } from 'hooks';
import { connectStats } from 'react-instantsearch-core';
import CategoryChip from '../CategoryChip';

export const InCategorySearchList = ({ values, nbHits }) => {
    const [query] = useQuery();

    const rootClassnames = classnames(
        'category-list-root',
        'intra-category__filters-list',
    );

    return (
        <ul className={rootClassnames}>
            {values.map(
                ({ active, id, imageUrl, label, url, level, slug }, index) => (
                    <CategoryChip
                        imageUrl={imageUrl}
                        label={label}
                        url={url}
                        key={id}
                        active={active}
                        level={level}
                        id={id}
                        slug={slug}
                        rank={index + 1}
                        nbHits={nbHits}
                        searchQuery={query}
                    />
                ),
            )}
        </ul>
    );
};

InCategorySearchList.propTypes = {
    values: arrayOf(
        shape({
            active: bool,
            id: number.isRequired,
            imageUrl: string.isRequired,
            label: string.isRequired,
            url: string.isRequired,
        }),
    ).isRequired,
    nbHits: number,
};

InCategorySearchList.defaultProps = {
    nbHits: 0,
};

export default connectStats(InCategorySearchList);
